<style scoped lang="scss">
  ._formList /deep/ .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 28px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 545px;
  }
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/in/order/detail/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <div style="margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
          {{$t('rukudantouxinxi')}}
        </div>
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
          <el-form-item class="noborder" :label="$t('danjuleixing')" required>
            <el-select disabled v-model="$attrs.check.type" @change="$forceUpdate()">
              <el-option :label="$t('shengchanruku')" :value="2"></el-option>
              <el-option :label="$t('tuihuoruku')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('kehumingcheng')">
            <el-input disabled v-model="$attrs.check.wmsCustomer==null?'':$attrs.check.wmsCustomer.name"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('danjuriqi')" required>
            <el-date-picker
                v-model="$attrs.check.billDate"
                type="date"
                value-format="timestamp"
                format="yyyy-MM-dd"
                disabled
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('beizhu')">
            <el-input disabled v-model="$attrs.check.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 明细状态 -->
      <template #mingxizhuangtai="scope">
        <span v-if="scope.row.status===0">{{$t('weiruku')}}</span>
        <span v-if="scope.row.status===1">{{$t('bufenruku')}}</span>
        <span v-if="scope.row.status===2">{{$t('quanburuku')}}</span>
      </template>
      <template #chanpinbianmamingcheng="scope">
        <span>{{scope.row.material.code}}/{{scope.row.material.name}}</span>
      </template>
      <template #danwei="scope">
        {{$t(store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][scope.row.unit])}}
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <div style="margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
          {{$t('rukudanmingxixinxi')}}
        </div>
        <!-- 批量入库按钮 -->
        <el-button :disabled="$attrs.check.status == 2" size="mini" @click="yt.showEditDialog('piliangruku',null,'70%',beforeShowEditDialog);" type="primary">
          {{$t('piliangruku')}}
        </el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status===0||scope.row.status===1">
            <el-button type="text" @click="yt.showEditDialog('ruku', scope.row,'w2',beforShowRukuEditDialog);">{{$t('ruku')}} </el-button>
          </el-col>
          <!-- 撤销入库 -->
          <el-col :span="0.1" v-if="scope.row.status === 2 || scope.row.status === 1">
            <el-popconfirm title="是否确认撤销当前记录?" confirm-button-text="是" cancelButtonText="否" @confirm="reversePutIn(scope.row)" v-if="utils.checkPower('web_wms_in_order_product_reversePutIn')"  v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '成品入库-撤销入库' } }">
              <el-button type="text" slot="reference" style="color: #f67171;">
                {{$t('chexiao')}}
              </el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增 -->
      <template v-if="yt.editObj.action == 'ruku'">
        <div class="dialog-scroller">
          <!--          {{$attrs.check.materialId}}-->
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
              <yi_cross_select disabled :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('danwei')">
              <!--              <span>{{$attrs.check}}</span>-->
              <el-input disabled v-model="store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][yt.editObj.unit]"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('rukushuliang')">
              <el-input disabled v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('weishoushuliang')">
              <!--              <el-input disabled v-model="yt.editObj.quantity-yt.editObj.actualQuantity"></el-input>-->
              <el-input disabled v-model="yt.editObj.dueQuantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bencishishou')" required>
              <el-input-number v-model="yt.editObj.newReceiveQuantity" :min="0" :max="yt.editObj.quantity"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('cangku/kuqu/kuwei')" required>
              <yi_data_select class="_formList" :key="'1'" :showAllLevels="true" :multiple="false" :max="1" :checkStrictly="true" :warehouseLevel="2" :type="'warehouse'" :idsPathParent.sync="yt.editObj.idsPathParent" :ids.sync="yt.editObj.warehouseId"> </yi_data_select>
            </el-form-item>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/in/order/detail/putIn',beforeRuku)" type="primary">
            {{$t('baocun')}}
          </el-button>
        </span>
      </template>
      <!-- 批量入库-->
      <template v-if="yt.editObj.action == 'piliangruku'">
        <div class="dialog-scroller" style="margin-left: 40px">
          <batch_put_in ref="inBoundAdd" :check="checkEntity"></batch_put_in>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="submitInbound" type="primary">
            {{$t('baocun')}}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
  import batch_put_in from '@@/pages/web/wms/in_order_product/check/batch_put_in'
  export default {
    name: 'web_wms_in_order_product_check_list',
    components: {
      batch_put_in
    },
    data() {
      return {
        warehouseAreaIdDisabled: true,
        warehouseLocationIdDisabled: true,
        planCodeList: [],
        warehouseId: null,
        areaId: null,
        show: false,
        isShowAreaCode:true,
        isShowLocation:true,
        exceptionTypeList: [],
        columns: [{
          label: 'chanpinbianmamingcheng',
          // prop: 'material.name',
          type: 'slot',
          // width: 170,
        }, {
          label: 'chanpinpicihao',
          prop: 'materialBatchNo',
          width: 130,
        }, {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 130,
        }, {
          label: 'danwei',
          prop: 'unit',
          type: 'slot',
          width: 130,
        }, {
          label: 'rukushuliang',
          prop: 'quantity',
          width: 130,
        }, {
          label: 'mingxizhuangtai',
          prop: 'status',
          type: 'slot',
          width: 130,
        }, {
          label: 'shishoushuliang',
          prop: 'actualQuantity',
          width: 130,
        },
          {
            label: 'beizhu',
            prop: 'remark',
            width: 180,
          },

          {
            label: 'caozuo',
            type: 'slot',
            width: 150,
            fixed: 'right'
          }
        ]
      };
    },
    created() {
      setTimeout(() => {
        this.yt.conditions = {
          inOrderId: this.$attrs.check.id,
        }
        this.yt.get(1);
        this.checkEntity = this.$attrs.check;
      }, 300)
    },
    mounted() {
      console.log('fffff',this.$attrs.check)


    },
    watch: {
      'isShowAreaCode': {
        handler(n) {
          if (n==false) {
            console.log('hhhhhhhhhhhhhhh',n)
            this.warehouseAreaIdDisabled = false
          }
        },
        immediate: false,
        deep: true
      },
      'isShowLocation': {
        handler(n) {
          if (n==false) {
            console.log('hhhhhhhhhhhhhhh',n)
            this.warehouseLocationIdDisabled = false
          }
        },
        immediate: false,
        deep: true
      },
    },
    methods: {
      beforeRuku(params){
        console.log('params111222',params.idsPathParent)
        params.warehouseId = params.idsPathParent[0]?params.idsPathParent[0]:null
        params.warehouseAreaId = params.idsPathParent[1]?params.idsPathParent[1]:null
        params.warehouseLocationId = params.idsPathParent[2]?params.idsPathParent[2]:null
        console.log('params111222',params)
        return params

      },
      getItems(checks) {
        this.warehouseId = checks.id
        console.log('check', checks)

        //重置第二个选择框
        this.isShowAreaCode = false
        this.yt.editObj.warehouseAreaId = null
        this.$nextTick(()=>{
          this.isShowAreaCode = true
        })


      },
      getItem(checks) {
        // isShowLocation
        this.areaId = checks.id
        console.log('checkqq', checks)
        this.isShowLocation = false
        this.yt.editObj.warehouseLocationId = null
        this.$nextTick(()=>{
          this.isShowLocation = true
        })
      },
      beforeShowEditDialog(editObj) {
        console.log('editObj', editObj)
        return editObj
      },

      beforShowRukuEditDialog(editObj) {
        console.log("权限：",this.utils.checkPower('web_wms_ware_house_auto_full'))

        if (!this.utils.checkPower('web_wms_ware_house_auto_full')) {
          //非客制化用户，不执行该逻辑
          return editObj;
        }
        editObj.newReceiveQuantity = editObj.quantity
        this.http.get('/web/material/warehouse/getLatestOne', {params:{materialId: editObj.material.id}}).then(res => {
          if (!res.data) {
            return;
          }
          if(res.data.warehouseLocationId){
            this.$set(this.yt.editObj, 'warehouseId', parseInt('3'+res.data.warehouseLocationId));
            return
          }
          if(res.data.warehouseAreaId){
            this.$set(this.yt.editObj, 'warehouseId', parseInt('2'+res.data.warehouseAreaId));
            return
          }
          if(res.data.warehouseId){
            this.$set(this.yt.editObj, 'warehouseId', parseInt('1'+res.data.warehouseId));
            return
          }
        }).catch(error=>{
          this.$message.error(error)
        })
        return editObj
      },



      submitInbound() {


        const res = this.$refs['inBoundAdd'].$refs['form'].validate(valid => {
          // if (!valid) {
          //   return false
          // }
          console.log('submit',this.$refs['inBoundAdd'].form )
          let form = this.$refs['inBoundAdd'].form
          const fieldsToConcat = [
            { field: 'warehouseId', prefix: '1' },
            { field: 'warehouseAreaId', prefix: '2' },
            { field: 'warehouseLocationId', prefix: '3' }
          ];

          for (let i = 0; i < form.inOrderDetailList.length; i++) {
            for (let { field, prefix } of fieldsToConcat) {
              if (form.inOrderDetailList[i][field] != null) {
                form.inOrderDetailList[i][field] = prefix + form.inOrderDetailList[i][field];
              }
            }
          }
          return this.http.post('/web/in/order/detail/batchPutIn', form.inOrderDetailList).then(response => {
            this.yt.get(1)
            this.yt.isShowEditDialog = false;
            this.$message.success(this.$t(response.msg))
          }).catch(error => {
            this.$message.error(error)
          })

        })
      },
      reversePutIn(data) {
        this.http
          .post('/web/in/order/detail/reversePutIn', data)
          .then(res => {
            this.$message({
              message: this.$t('success'),
              type: 'success'
            });
            this.yt.get(1);
          })
          .catch(error => {
            this.$message.error(this.$t(error));
          });
      },
    }
  };
</script>
